import React, {
  useContext,
  useState,
  useEffect,
  Fragment,
} from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Button from '../../../components/Button';
import Dropzone from '../../../components/Dropzone';
import Select from '../../../components/Select';
import useFetch from '../../../services/useFetch';
import Form from '../../../components/Form';
import Title from '../../../components/Title';
import { DispatchDialogContext } from '../../../providers/DialogProvider/DialogContext';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2, 2),
    background: '#f5f5f5',
    margin: theme.spacing(2, 0, 1, 0),
  },
}));

const selectOptions = [
  {
    label: 'Excel salud',
    value: '/service/v1/health/upload-masive',
  },
  {
    label: 'Excel colaboradores',
    value: '/service/v1/collaborator/upload-masive',
  },
  {
    label: 'Excel descuento',
    value: '/service/v1/discount/upload-masive',
  },
];

const fetchLogConfig = {
  initalMethod: 'get',
  initialUri: '/service/v1/uploads',
  showSuccessMessage: false,
  showErrorMessage: false,
};

const formConfig = {
  initalMethod: 'post',
  initialForm: { masive: 1, file: null },
  contentType: 'multipart/form-data',
};

const headerslog = [
  { label: 'Tipo excel', colSize: '3' },
  { label: 'Fecha', colSize: '2' },
  { label: 'Hora', colSize: '2' },
  { label: 'Archivo', colSize: '5' },
];

const MassiveUpload = () => {
  const {
    uri, setUri, form, setForm, fetch, isLoading,
  } = useFetch(formConfig);
  const fetchLog = useFetch(fetchLogConfig);
  const [lastUploads, setLastUploads] = useState([]);
  const dialog = useContext(DispatchDialogContext);
  const classes = useStyles();

  async function fetchLogList() {
    const { success, data } = await fetchLog.fetch();
    if (success) {
      setLastUploads(data);
    }
  }

  useEffect(() => {
    fetchLogList();
  }, []);

  function handleSelectChange(event) {
    const { target } = event;
    const { value } = target;
    setUri(value);
  }

  function handleDropzoneChange(files) {
    const file = files.length > 0 ? files[0] : null;
    setForm({ masive: 1, file });
  }

  function handleReset() {
    setForm({ masive: 1, file: null });
    setUri('');
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (uri) {
      const { success, message, data } = await fetch();

      const arr = Object.keys(data).reduce((res, v) => {
        return res.concat(data[v]);
      }, []);
      const totalMsg = `${message}. ${arr.join('')}`;
      
      dialog({
        type: success ? 'success' : 'error',
        content: totalMsg,
      });
      if (success) {
        handleReset();
      }
    }
  }

  return (
    <Form xs={12} onSubmit={handleSubmit}>
      <Title variant="h5" component="h2">Carga masiva</Title>

      <Select
        id="excel"
        name="excelType"
        label="Tipo de Excel *"
        options={selectOptions}
        onChange={handleSelectChange}
        value={uri}
        required
      />

      <Dropzone
        label="Seleccione o arrastre el archivo."
        value={form.file}
        onChange={handleDropzoneChange}
      />

      <Button color="primary" type="submit" disabled={isLoading} square>Cargar archivo</Button>

      <Paper className={classes.root}>
        <Typography variant="button" display="block" gutterBottom>
          Última carga realizada:
        </Typography>
        <Grid container spacing={1}>
          {
            headerslog.map(item => (
              <Grid item sm={item.colSize}>
                <Title variant="caption">{item.label}</Title>
              </Grid>
            ))
          }
        </Grid>

        <Grid container spacing={1}>
          {
            !lastUploads.length
              ? (
                <Typography variant="caption" display="block" gutterBottom>
                  Sin datos que mostrar.
                </Typography>
              )
              : (
                lastUploads.map((item) => {
                  let excelType = '';

                  switch (item.file_type) {
                    case 'health':
                      excelType = 'Excel Salud';
                      break;
                    case 'collaborator':
                      excelType = 'Excel colaboradores';
                      break;
                    default:
                      excelType = 'Excel descuento';
                      break;
                  }

                  return (
                    <Fragment>
                      <Grid item sm={3}>
                        <Typography variant="caption" display="block" gutterBottom>
                          { excelType }
                        </Typography>
                      </Grid>
                      <Grid item sm={2}>
                        <Typography variant="caption" display="block" gutterBottom>
                          { item.created_date.split(' ')[0] }
                        </Typography>
                      </Grid>
                      <Grid item sm={2}>
                        <Typography variant="caption" display="block" gutterBottom>
                          { item.created_date.split(' ')[1] }
                        </Typography>
                      </Grid>
                      <Grid item sm={5}>
                        <Typography variant="caption" display="block" gutterBottom>
                          { `${item.file_path}.xls` }
                        </Typography>
                      </Grid>
                    </Fragment>
                  );
                })
              )
          }
        </Grid>
      </Paper>
    </Form>
  );
};
export default MassiveUpload;
